import { getAllCustomerProducts } from "../../config/config";
import { toast } from "react-toastify";

export const GET_ALL_CUSTOMER_PRODUCTS_SUCCESS = "GET_ALL_CUSTOMER_PRODUCTS_SUCCESS";
export const GET_ALL_CUSTOMER_PRODUCTS = "GET_ALL_CUSTOMER_PRODUCTS_SUCCESS";

const actions = {
	//GET ALL CUSTOMER PRODUCTS
	getAllCustomerProducts: (filters) => (dispatch) => {
		dispatch({
			type: GET_ALL_CUSTOMER_PRODUCTS,
			payload: {
				getAllCustomerProductsLoading: true,
			},
		});
		getAllCustomerProducts(filters).then((res) => {
			dispatch({
				type: GET_ALL_CUSTOMER_PRODUCTS,
				payload: {
					getAllCustomerProductsLoading: false,
				},
			});
			if (res?.status === 200) {
				dispatch({
					type: GET_ALL_CUSTOMER_PRODUCTS_SUCCESS,
					payload: {
						allCustomerProducts: res?.data?.customerProducts,
					},
				});
			} else if (res?.status === 401) {
				window.location = "/session-ended";
			} else if (res?.status === 403) {
				window.location = "/forbidden";
			} else {
				toast.error(res?.data?.message || "error", { theme: "colored" });
			}
		});
	},

};

export default actions;
